<section>
  <div class="content-2">
    <div class="title-container">
      <h1 class="title">Funcionários: quantidade por função</h1>
      <h2 class="subtitle">
        Valores calculados pelo simulador a partir de parâmetros informados.
      </h2>
    </div>

    <hr class="division-line" />

    <div class="panel">
      <div class="table-wrapper">
        <app-tabela class="table-component" [cabecalhos]="cabecalhoTabela">
          <ng-container corpo>
            <tbody>
              <tr *ngFor="let dados of dadosTabela?.projecoes; let i = index">
                <ng-container *ngIf="dadosTabela != null && dadosTabela.projecoes.length !== i">
                  <td class="align-left px-4 py-2">{{ dados.etapa }}</td>
                  <td
                    *ngIf="i === 0"
                    class="text-blue bold align-right"
                    [attr.rowspan]="dadosTabela && dadosTabela.projecoes ? dadosTabela.projecoes.length : 0"
                  ></td>
                  <td class="align-right px-4 py-2">{{ dados.projecao | number:'1.0-0'}}</td>
                </ng-container>
              </tr>
              <tr class="total-line">
                <td class="align-left bold px-4 py-2">Total</td>
                <td class="text-blue bold align-right px-4 py-2">
                  {{ dadosTabela?.totalNumeroFuncionarios ?? 0 | number:'1.0-0'}}
                </td>
                <td class="align-right bold px-4 py-2">
                  {{ dadosTabela?.totalFuncionariosPorFuncao ?? 0 | number:'1.0-0'}}
                </td>
              </tr>
            </tbody>
          </ng-container>
        </app-tabela>
        <app-rodape-fonte-nota [foteNota]="notasFonte"> </app-rodape-fonte-nota>
      </div>
    </div>
  </div>
</section>
